// @mui material components
import { Theme } from "@mui/material/styles";

function defaultItemIconBox(theme: Theme, ownerState: any) {
  const { functions, palette, borders } = theme;
  const { color } = ownerState;

  const { pxToRem, linearGradient } = functions;
  const { gradients, dark, white } = palette;
  const { borderRadius } = borders;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: pxToRem(48),
    height: pxToRem(48),
    minWidth: pxToRem(48),
    minHeight: pxToRem(48),
    borderRadius: borderRadius.md,
    color: color === "light" ? dark.main : white.main,
    background: gradients[color]
      ? linearGradient(gradients[color].main, gradients[color].state)
      : linearGradient(gradients.info.main, gradients.info.state),
  };
}

export default defaultItemIconBox;
